export enum Shapes {
  square = 'square',
  circle = 'circle',
  rectangular = 'rectangular',
  custom = 'custom',
}
